export interface WidgetSizeConfig {
  minWidth: number
  minHeight: number
  maxWidth: number
  maxHeight: number
  defaultWidth: number
  defaultHeight: number
}

export enum WidgetType {
  NV_TRADED = 'nv-traded',
  LOTS_TRADED = 'lots-traded',
  FIRST_TIME_DEPOSIT = 'first-time-deposit',
  DEPOSITS = 'total-deposits',
  NET_DEPOSITS = 'net-deposits',
  NEW_CLIENTS = 'new-clients',
  ACTIVE_CLIENTS = 'active-clients',
  OPENED_TA = 'trading-accounts-opened',
  ACTIVE_TA = 'active-trading-accounts',
  IB_COMMISSIONS = 'commissions-paid',
  IB_METRICS_COMPARISON = 'metric-comparison',
  CJM = 'cjm',
}

export const ALLOWED_WIDGET_TYPES = Object.values(WidgetType)

export interface WidgetLayout {
  i: string
  x: number
  y: number
  w: number
  h: number
  minW?: number
  minH?: number
  maxW?: number
  maxH?: number
  static?: boolean
}

export interface Widget {
  id: string
  widgetId: string // backend GUID
  type: WidgetType
  size: WidgetSizeConfig
  title: string
  layout: WidgetLayout
  config?: Record<string, unknown>
}

export interface DashboardLayout {
  id: string
  name: string
  description: string
  isPreset: boolean
  widgets: Widget[]
}

export const MAX_CUSTOM_LAYOUTS = 10
export const LAYOUT_NAME_REGEX = /^[A-Za-z0-9 -]+$/
export const TITLE_LIMIT = 25
export const DESCRIPTION_LIMIT = 150
